<!--
 * @Author: caojianbo bshengtong@163.com
 * @Date: 2023-10-08 15:01:28
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-10-30 15:11:00
 * @FilePath: \fe-crm\src\views\setting\sys-fields\page-layout\components\layout-header\layout-header.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="page-layout-header">
    <jw-card :bordered="false" class="list-layout-content">
      <template #title>
        <div class="layout-title">
          <div>{{ props.title }}</div>
          <template v-if="grayList['Layout:viewInit'] && splitType">
            <jw-tag :color="splitType == 2 ? '#843CE2' : '#1FB5CC'" size="small">{{ splitType == 2 ? $t('与表单设计保持一致') : $t('自定义详情页') }}</jw-tag>
          </template>
        </div>
      </template>
      <template #extra>
        <jw-button style="margin-right: 10px" @click="cancelLayout">{{ $t('关闭') }}</jw-button>
        <jw-button @click="save(1)" type="primary" style="margin-right: 10px" :loading="loading">{{ $t('保存并关闭') }}</jw-button>
        <jw-button @click="save(2)" type="primary" :loading="loading">{{ $t('保存') }}</jw-button>
      </template>
    </jw-card>
  </div>
</template>

<script setup>
import { inject } from 'vue';
import { useGrayscaleStore } from '@/store';
const splitType = inject('sharedConfigData')?.splitType; // 布局分裂模式
const { grayList } = useGrayscaleStore(); //用户信息
console.log('1-开始创建组件-setup', splitType);
const emits = defineEmits(['cb', 'saveLayout']);
const props = defineProps({
  title: {
    //标题
    type: String,
    default: '布局设置'
  },
  loading: {
    type: Boolean,
    default: false
  }
});

// });
const cancelLayout = () => {
  emits('cb');
};
const save = (type) => {
  emits('saveLayout', type);
};
// const layoutNameRef = ref();
</script>
<style scoped lang="less">
@import './layout-header.less';
</style>
